import React, { useEffect } from 'react';
import { apiCallAsync, apiCall } from '../apiclient';
import { bootUser } from '../util';
import { config } from '../config';
import { User } from '../classes/User';
import { Container, Navbar, Nav, NavDropdown, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function UserMenu(props) {

    useEffect(() => {
        if(props.user.uuid === '') {
            apiCall('get', 'users/current').then((u) => {
                props.updateUser(new User(u.users[0]));
            }).catch((err) => {
                console.error(err);
                props.updateUser({uuid: null});
                throw(err);
            });
        }
    }, [props.user.uuid]);

    if(props.user.uuid === null) {
        return(bootUser());
    }
    if(props.user.uuid === "") {
        return(
            <center>
            Loading the application, please wait&nbsp;&nbsp;<br></br>
            <Spinner animation="border" size="lg" />
            </center>
        )
    } else {
        let u = new User(props.user);
        return(
            <Navbar bg="dark" variant="dark" expand="md" sticky="top">
                <Container>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <NavDropdown title="Explore" id="basic-nav-dropdown">
                                <NavDropdown.Item as={Link} to="/app/users/browse">Browse</NavDropdown.Item>
                            </NavDropdown>
                            <DJMenu user={u} />
                            <MCMenu user={u} />
                            <PartyHostMenu user={u} />
                        </Nav>
                    </Navbar.Collapse>
                    <MyInfoMenu user={u} />
                </Container>
            </Navbar>
        );
        // console.log(JSON.stringify(props.user));
        //return(<h1><center>This is a test for {props.user.data.display_name}</center></h1>);
    }
}

function DJMenu(props) {
    if (props.user.hasRole('dj'))
        return (
        <NavDropdown title="DJs" id="basic-nav-dropdown">
            <NavDropdown.Item as={Link} to="/app/dj/import">Import Songs</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/app/dj/tags">Song Tags</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/app/dj/lists">Song Lists</NavDropdown.Item>
        </NavDropdown>
        ) 
    else return(null);
}

function MCMenu(props) {
    if (props.user.hasRole('emcee'))
        return (
        <NavDropdown title="MCs" id="basic-nav-dropdown">
            <NavDropdown.Item as={Link} to="/app/mc/parties">Plan Parties</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/app/mc/findDJ">Search DJs</NavDropdown.Item>
        </NavDropdown>
        ) 
    else return(null);
}

function PartyHostMenu(props) {
    if (props.user.hasRole('party_host'))
        return (
        <NavDropdown title="Party Hosts" id="basic-nav-dropdown">
            <NavDropdown.Item as={Link} to="/app/partyhost/findMC">Search MCs</NavDropdown.Item>
        </NavDropdown>
        ) 
    else return(null);
}

function MyInfoMenu(props) {
    if (props.user.hasRole('admin')) {
        return (
        <Navbar.Collapse className="justify-content-end">
        <Nav className="justify-content-end">
        <NavDropdown title={props.user.data.display_name} id="basic-nav-dropdown">
            <NavDropdown.Item as={Link} to="/app/users/info">My Info</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item as={Link} to="/app/admin/useradmin">User Administration</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href={config.logoutURI}>Logout</NavDropdown.Item>
        </NavDropdown>
        </Nav>
        </Navbar.Collapse>
        ) } else { return (
        <Navbar.Collapse className="justify-content-end">
        <Nav className="justify-content-end">
        <NavDropdown title={props.user.data.display_name} id="basic-nav-dropdown">
            <NavDropdown.Item as={Link} to="/app/users/info">My Info</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item href={config.logoutURI}>Logout</NavDropdown.Item>
        </NavDropdown>
        </Nav>
        </Navbar.Collapse>
        )
    }
}